<template>
  <div class="page">
    <!-- 顶栏 -->
    <div class="top-bar">
      <div class="brand">
        <div class="logo">Z</div>
        <div class="brand-text">
          <span class="brand-name">致善阔贤管理系统</span>
          <span class="brand-desc">Zero Platform</span>
        </div>
      </div>
      <div class="search-box">
        <i class="el-icon-search"></i>
        <input v-model="searchKey" placeholder="搜索栏" />
      </div>
      <div class="top-actions">
        <div class="ai-badge">Ai</div>
        <i
          class="top-icon"
          :title="isFullscreen ? '退出全屏' : '全屏'"
          @click="handleFullScreen"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 9V6a2 2 0 0 1 2-2h3M20 9V6a2 2 0 0 0-2-2h-3M4 15v3a2 2 0 0 0 2 2h3M20 15v3a2 2 0 0 1-2 2h-3"></path>
          </svg>
        </i>
        <i
          class="top-icon"
          v-if="!isCollapse"
          title="折叠导航"
          @click="toggleCollapse"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="12" x2="15" y2="12"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </i>
        <i
          class="top-icon"
          v-else
          title="展开导航"
          @click="toggleCollapse"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="9" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </i>
        <el-popover
          placement="bottom"
          width="220"
          trigger="click"
        >
          <div class="notice-panel">
            <div class="notice-title">通知</div>
            <div class="notice-empty">暂无通知</div>
          </div>
          <i slot="reference" class="top-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </i>
        </el-popover>
        <el-dropdown trigger="click" placement="bottom-end">
          <div class="user-chip">
            <div class="avatar"><i class="el-icon-user-solid"></i></div>
            <i class="el-icon-arrow-down caret"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-pop">
            <div class="user-pop-head">
              <div class="user-pop-avatar"><i class="el-icon-user-solid"></i></div>
              <span class="user-pop-name">超级管理员CC</span>
            </div>
            <div class="user-pop-logout" @click="handleLogout">退出登录</div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="content">
      <Nav
        class="left"
        :isCollapse="isCollapse"
        :navData="filterNavList"
        :active="active"
        @clickNav="clickNav"
        @collapse="collapse"
        :style="{ width: leftWidth }"
      ></Nav>

      <div class="right" :style="{ width: rightWidth }">
        <!-- 多路由标签页 -->
        <div class="tags-view">
          <div class="tags-scroll" ref="tagsScroll">
            <div
              v-for="(tab, index) in openTabs"
              :key="tab.key"
              class="tag-item"
              :class="{ active: tab.key === activeTab }"
              @click="clickTab(tab.key)"
            >
              <span class="tag-title">{{ tab.title }}</span>
              <i
                v-if="index !== 0"
                class="el-icon-close tag-close"
                @click.stop="closeTab(tab.key)"
              ></i>
            </div>
          </div>
        </div>
        <div class="content_right">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/navMenu/index.vue";
import { mapState, mapMutations } from "vuex";
import screenfull from "screenfull";
export default {
  components: {
    Nav
  },

  async mounted() {
    /* 根据权限初始化导航 迁移到了store*/
    // this.navData = JSON.parse(JSON.stringify(this.navList));
    // this.filterFun(this.navData, this.roleList);
    // this.$store.commit("updataFilterNavList", this.navData);
    /* 初始化导航高亮 */
    // this.findFun(
    //   this.filterNavList,
    //   window.location.hash.substring(1, window.location.hash.length)
    // );
    // if (!this.active) {
    //   this.$router.push({ name: "Error" });
    //   return;
    // }
    if (screenfull.enabled) {
      screenfull.on("change", () => {
        this.isFullscreen = screenfull.isFullscreen;
      });
    }
  },

  beforeDestroy() {
    if (screenfull.enabled) {
      screenfull.off("change");
    }
  },

  data() {
    return {
      isCollapse: false, //是否折叠导航栏
      isFullscreen: false,
      leftWidth: "220px",
      rightWidth: "calc(100% - 220px)",
      routerName: "",
      searchKey: "",
      roleList: [], //权限
      openTabs: [], //已打开的标签页 {key: 路由名, title: 显示名}
      activeTab: "" //当前激活标签的 key
    };
  },
  computed: {
    ...mapState(["userInfo", "filterNavList", "active"]),
    /* 把多级导航拍平成 路由名 -> 显示名 的映射，用于标签标题 */
    flatNavMap() {
      const map = {};
      const walk = list => {
        (list || []).forEach(item => {
          if (item.routerName) map[item.routerName] = item.label;
          if (item.children && item.children.length) walk(item.children);
        });
      };
      walk(this.filterNavList);
      return map;
    }
  },
  watch: {
    /* 路由变化 → 同步标签：自动新增当前页标签并高亮 */
    $route: {
      immediate: true,
      handler(route) {
        if (!route || !route.name) return;
        const title = this.flatNavMap[route.name] || route.name;
        this.addTab(route.name, title);
        this.activeTab = route.name;
        this.$nextTick(this.scrollActiveIntoView);
      }
    },
    /* 导航权限加载完成后，回填已有标签的标题 */
    filterNavList() {
      this.openTabs.forEach(t => {
        if (this.flatNavMap[t.key]) t.title = this.flatNavMap[t.key];
      });
    }
  },
  methods: {
    ...mapMutations(["updataActive"]),
    /* 退出登录 */
    handleLogout() {
      localStorage.removeItem("token");
      this.$router.push("/");
    },
    clickNav(item) {
      // this.active = item.id;
      this.updataActive(item.id);
      this.routerName = item.routerName;
      this.$router.push({ name: item.routerName });
    },
    collapse(isCollapse) {
      this.isCollapse = isCollapse;
      if (isCollapse) {
        this.leftWidth = "65px";
        this.rightWidth = "calc(100% - 65px)";
      } else {
        this.leftWidth = "220px";
        this.rightWidth = "calc(100% - 220px)";
      }
    },
    /* 折叠/展开导航（顶栏按钮） */
    toggleCollapse() {
      this.collapse(!this.isCollapse);
    },
    /* 全屏 */
    handleFullScreen() {
      if (!screenfull.enabled) {
        this.$message.info("您的浏览器版本过低，不支持全屏浏览");
        return false;
      }
      screenfull.toggle();
    },
    /* ===== 多路由标签页 ===== */
    /* 新增标签（已存在则不重复添加） */
    addTab(key, title) {
      if (!key) return;
      if (!this.openTabs.some(t => t.key === key)) {
        this.openTabs.push({ key, title: title || key });
      }
    },
    /* 点击标签 → 切换路由 */
    clickTab(key) {
      if (this.activeTab === key) return;
      this.$router.push({ name: key });
    },
    /* 关闭标签 */
    closeTab(key) {
      const idx = this.openTabs.findIndex(t => t.key === key);
      if (idx === -1) return;
      // 第一个标签固定，不可关闭
      if (idx === 0) return;
      // 至少保留 1 个标签，不允许全部关闭
      if (this.openTabs.length <= 1) return;
      this.openTabs.splice(idx, 1);
      // 关闭的是当前激活标签 → 跳转到剩下最后一个标签
      if (this.activeTab === key) {
        const next = this.openTabs[this.openTabs.length - 1];
        this.activeTab = next.key;
        this.$router.push({ name: next.key });
      }
    },
    /* 把激活标签滚动到可视区域 */
    scrollActiveIntoView() {
      const el = this.$refs.tagsScroll;
      if (!el) return;
      const active = el.querySelector(".tag-item.active");
      if (active) {
        active.scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
      }
    }
    /*  找到导航 id */
    // findFun(navData, path) {
    //   for (let index = 0; index < navData.length; index++) {
    //     if (navData[index]?.path === path) {
    //       this.active = navData[index]?.id;
    //     }
    //     if (
    //       navData[index]?.children &&
    //       navData[index]?.children.length > 0 &&
    //       navData[index]?.path !== path
    //     ) {
    //       this.findFun(navData[index].children, path);
    //     }
    //   }
    // },

    /* 筛选全量导航 */
    // filterFun(navData, roleList) {
    //   for (var index = navData.length - 1; index >= 0; index--) {
    //     if (
    //       navData[index]?.children &&
    //       navData[index]?.children.length > 0 &&
    //       roleList?.indexOf(navData[index].id) >= 0
    //     ) {
    //       this.filterFun(navData[index].children);
    //     }
    //     if (roleList?.indexOf(navData[index].id) < 0) {
    //       navData.splice(index, 1);
    //     }
    //   }
    // },
  }
};
</script>
<style lang="less" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 800px;
}
/* 顶栏 */
.top-bar {
  height: 60px;
  flex-shrink: 0;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid #f0f1f5;
  .brand {
    display: flex;
    align-items: center;
    .logo {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      background: #3D8DFC;
      color: #fff;
      font-size: 20px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .brand-text {
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      line-height: 1.25;
      .brand-name {
        font-size: 16px;
        font-weight: 700;
        color: #1d2129;
      }
      .brand-desc {
        font-size: 11px;
        color: #86909c;
      }
    }
  }
  .search-box {
    flex: 1;
    max-width: none;
    margin-left: 100px;
    height: 36px;
    background: #f7f8fa;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 0 14px;
    i {
      color: #86909c;
      font-size: 15px;
    }
    input {
      flex: 1;
      min-width: 0;
      margin-left: 8px;
      border: none;
      outline: none;
      background: transparent;
      font-size: 13px;
      color: #1d2129;
      &::placeholder {
        color: #a9aeb8;
      }
    }
  }
  .top-actions {
    margin-left: 20px;
    display: flex;
    align-items: center;
    .ai-badge {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background: #f7f8fa;
      color: #1d2129;
      font-size: 14px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .top-icon {
      margin-left: 20px;
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background: #f7f8fa;
      font-size: 19px;
      color: #1d2129;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      svg {
        width: 18px;
        height: 18px;
      }
    }
    .user-chip {
      margin-left: 20px;
      height: 36px;
      width: 200px;
      box-sizing: border-box;
      padding: 0 12px 0 4px;
      border-radius: 8px;
      background: #f7f8fa;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      .avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: #fff;
        color: #4e5969;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .caret {
        margin-left: 6px;
        font-size: 12px;
        color: #86909c;
      }
    }
  }
}
.content {
  flex: 1;
  width: 100%;
  margin: 0 auto;
  display: flex;
  min-height: 0;
  .left {
    // outline: 1px solid red;
    overflow-y: auto;
  }
  .right {
    // border: 5px solid red;
    height: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
    background: #F1F6FC;
    /* 多路由标签页 */
    .tags-view {
      flex-shrink: 0;
      height: 42px;
      display: flex;
      align-items: center;
      background: #fff;
      border-bottom: 1px solid #f0f1f5;
      padding: 0 12px;
      .tags-scroll {
        flex: 1;
        min-width: 0;
        height: 100%;
        display: flex;
        align-items: center;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
        .tag-item {
          flex-shrink: 0;
          height: 28px;
          display: inline-flex;
          align-items: center;
          padding: 0 10px;
          margin: 0 4px;
          border-radius: 6px;
          background: #f2f3f5;
          color: #4e5969;
          font-size: 13px;
          cursor: pointer;
          user-select: none;
          transition: background 0.2s, color 0.2s;
          .tag-title {
            max-width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .tag-close {
            margin-left: 6px;
            width: 14px;
            height: 14px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            font-size: 12px;
            transition: background 0.2s, color 0.2s;
            &:hover {
              background: #c9cdd4;
              color: #fff;
            }
          }
          &.active {
            background: #e8f1ff;
            color: #3d8dfc;
            .tag-close:hover {
              background: #3d8dfc;
              color: #fff;
            }
          }
        }
      }
    }
    .content_right {
      flex: 1;
      min-height: 0;
      margin: 0;
      width: 100%;
      background: transparent;
      border-radius: 10px;
      overflow-y: auto;
      padding: 8px 12px;
    }
  }
}
</style>
<style lang="less">
/* 头像下拉弹窗（挂载在 body，需非 scoped） */
.el-dropdown-menu.user-pop {
  width: 200px;
  padding: 16px 12px;
  border: 1px solid #cfe0ff;
  background: #f1f6fc;
  border-radius: 14px;
  box-shadow: inset 0 0 0 3px #fff, 0 6px 24px rgba(0, 0, 0, 0.08);
  .user-pop-head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 16px;
  }
  .user-pop-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #8c86ff;
    color: #fff;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .user-pop-name {
    margin-left: 10px;
    font-size: 15px;
    font-weight: 700;
    color: #1d2129;
  }
  .user-pop-logout {
    height: 38px;
    line-height: 38px;
    text-align: center;
    background: #3d8dfc;
    color: #fff;
    font-size: 14px;
    border-radius: 10px;
    cursor: pointer;
    &:hover {
      background: #3D8DFC;
    }
  }
}
/* 去掉 el-dropdown-menu 默认小箭头 */
.el-popper[x-placement^="bottom"] .popper__arrow {
  display: none;
}

/* 通知面板（挂载在 body，需非 scoped） */
.notice-panel {
  .notice-title {
    font-size: 14px;
    font-weight: 600;
    color: #1d2129;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #f2f3f5;
  }
  .notice-empty {
    font-size: 13px;
    color: #86909c;
    text-align: center;
    padding: 16px 0;
  }
}
</style>
